import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import '../home/home.css';
import './provisionamento.css';
import '../../style/global.css';
import logo from '../../images/nortesoft_extendida_2_semfundo.png';
import Footer from '../../components/footer/footer';
import FloatingContactButton from '../../components/floatingcontact/floatingcontact';
import { COMMERCIAL_EMAIL, openMailto, openWhatsApp } from '../../services/contactChannels';

const initialState = {
    nomeFantasia: '',
    razaoSocial: '',
    segmento: '',
    contato: '',
    email: '',
    whatsapp: '',
    endereco: '',
    cidade: '',
    uf: '',
    cep: '',
};

function montarMensagem(values) {
    return [
        'Olá, Karlo. Recebi um novo pedido de provisionamento da Nortesoft.',
        '',
        'Dados da empresa:',
        `- Nome fantasia: ${values.nomeFantasia}`,
        `- Razão social: ${values.razaoSocial}`,
        `- Segmento: ${values.segmento}`,
        `- Cidade: ${values.cidade}`,
        `- UF: ${values.uf}`,
        `- CEP: ${values.cep}`,
        `- Endereço: ${values.endereco}`,
        '',
        'Contato responsável:',
        `- Nome: ${values.contato}`,
        `- E-mail: ${values.email || 'Não informado'}`,
        `- WhatsApp: ${values.whatsapp || 'Não informado'}`,
    ].join('\n');
}

const Provisionamento = () => {
    const [form, setForm] = useState(initialState);
    const [status, setStatus] = useState({ type: '', text: '' });

    const message = useMemo(() => montarMensagem(form), [form]);

    const handleChange = ({ target }) => {
        const { name, value } = target;
        setForm((current) => ({ ...current, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const requiredFields = [
            'nomeFantasia',
            'razaoSocial',
            'segmento',
            'contato',
            'endereco',
            'cidade',
            'uf',
            'cep',
        ];

        const missingField = requiredFields.find((field) => !String(form[field] || '').trim());

        if (missingField) {
            setStatus({
                type: 'error',
                text: 'Preencha os campos obrigatórios antes de enviar a solicitação.',
            });
            return;
        }

        openWhatsApp(message);
        openMailto({
            email: COMMERCIAL_EMAIL,
            subject: `Novo pedido de provisionamento - ${form.nomeFantasia}`,
            body: message,
        });

        setStatus({
            type: 'success',
            text:
                'Abrimos o WhatsApp e o e-mail com a solicitação estruturada para envio à Nortesoft.',
        });
    };

    return (
        <div className="ns-home">
            <header className="ns-header">
                <div className="ns-header__top">
                    <div className="ns-header__brand">
                        <img src={logo} alt="Nortesoft Tecnologia e Automação" className="ns-header__logo" />
                    </div>
                </div>

                <nav className="ns-header__nav is-open">
                    <Link to="/">Home</Link>
                    <Link to="/login">Entrar</Link>
                </nav>
            </header>

            <main className="ns-main">
                <section className="ns-section">
                    <div className="ns-section__heading">
                        <span className="ns-kicker">Provisionamento</span>
                        <h2>Envie os dados iniciais da sua empresa para receber atendimento comercial.</h2>
                        <p>
                            Preencha as informações principais do seu negócio. Vamos abrir o WhatsApp e o e-mail
                            com todos os dados estruturados para acelerar o seu atendimento.
                        </p>
                    </div>

                    <div className="ns-provisioning">
                        <article className="ns-provisioning__panel">
                            <h3>O que você envia aqui</h3>
                            <ul>
                                <li>Identificação principal da empresa</li>
                                <li>Endereço base de operação</li>
                                <li>Segmento do negócio</li>
                                <li>Responsável pelo contato inicial</li>
                            </ul>

                            <div className="ns-provisioning__actions">
                                <button type="button" className="ns-btn ns-btn--secondary" onClick={() => openWhatsApp('Olá, Nortesoft. Quero falar sobre a implantação de uma nova solução para a minha empresa.')}>
                                    Falar no WhatsApp
                                </button>
                            </div>
                        </article>

                        <form className="ns-provisioning__form" onSubmit={handleSubmit}>
                            <div className="ns-provisioning__grid">
                                <label>
                                    <span>Nome fantasia *</span>
                                    <input name="nomeFantasia" value={form.nomeFantasia} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>Razão social *</span>
                                    <input name="razaoSocial" value={form.razaoSocial} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>Segmento do negócio *</span>
                                    <input name="segmento" value={form.segmento} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>Pessoa de contato *</span>
                                    <input name="contato" value={form.contato} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>E-mail</span>
                                    <input name="email" type="email" value={form.email} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>WhatsApp</span>
                                    <input name="whatsapp" value={form.whatsapp} onChange={handleChange} />
                                </label>

                                <label className="ns-provisioning__field--full">
                                    <span>Endereço *</span>
                                    <input name="endereco" value={form.endereco} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>Cidade *</span>
                                    <input name="cidade" value={form.cidade} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>UF *</span>
                                    <input name="uf" maxLength="2" value={form.uf} onChange={handleChange} />
                                </label>

                                <label>
                                    <span>CEP *</span>
                                    <input name="cep" value={form.cep} onChange={handleChange} />
                                </label>
                            </div>

                            {status.text ? (
                                <div className={`ns-provisioning__status ${status.type === 'error' ? 'is-error' : 'is-success'}`}>
                                    {status.text}
                                </div>
                            ) : null}

                            <div className="ns-provisioning__submit">
                                <button type="submit" className="ns-btn ns-btn--primary">
                                    Enviar solicitação
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </main>

            <Footer />
            <FloatingContactButton />
        </div>
    );
};

export default Provisionamento;
